import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const SubmitButton = ({
  answers,
  questions,
  selectedOptions,
  handleSubmit,
}) => {
  const { t } = useTranslation();

  const allAnswered = Object.keys(answers).length === questions.length;
  const isDisabled =
    !allAnswered ||
    questions.some(
      (q) =>
        q.requiresDropdown &&
        answers[q.id] === "Yes" &&
        (!selectedOptions[q.id] || selectedOptions[q.id] === "")
    );

  return (
    allAnswered && (
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        sx={{ marginTop: 2 }}
        disabled={isDisabled}
      >
        {t("dashboard.decision-tree.buttons.submit")}
      </Button>
    )
  );
};

export default SubmitButton;
